module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-menu-dashboard/no-menu-dashboard.component.html
// module id = ./src/app/no-menu-dashboard/no-menu-dashboard.component.html
// module chunks = main